import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import {
  getKyrgyzstanAmenitiesRouteState,
  shouldShowFieldValue,
} from 'entities/kyrgyzstan'

import {
  DynamicField,
  DynamicFieldValue,
} from 'shared/api/kyrgyzstan/search/model'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface DynamicFieldsProps {
  popularDynamicFields: DynamicField[]
  dynamicFields: DynamicFieldValue
  realtyId: string
}

const MaxPopularDynamicFields = 3

export const DynamicFields = ({
  popularDynamicFields,
  dynamicFields,
  realtyId,
}: DynamicFieldsProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const slicedPopularDynamicFields = popularDynamicFields.slice(
    0,
    MaxPopularDynamicFields,
  )
  const moreFieldsCount =
    dynamicFields.count - slicedPopularDynamicFields.length

  const handleAllDynamicFieldsClick = () => {
    navigate(RoutingPaths.kyrgyzstan.allAmenities.path(realtyId), {
      state: getKyrgyzstanAmenitiesRouteState({
        id: realtyId,
        dynamicFields,
      }),
    })
  }
  return (
    <>
      <div className={s.amenitiesGrid}>
        {slicedPopularDynamicFields.map((field) => (
          <div
            key={field.id}
            className={s.amenityItem}
          >
            <AppIcon
              id={AllIcons.CHECK_MARK}
              width={16}
              height={16}
              className={s.amenityIcon}
            />
            <span className={clsx('medium-12', s.amenityLabel)}>
              {field.name}
              {shouldShowFieldValue(field) && (
                <span className={s.amenityValue}>
                  {': '}
                  {field.value}
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
      {moreFieldsCount > 0 && (
        <button
          type="button"
          className={clsx('medium-14', s.moreButton)}
          aria-label={t('kyrgyzstan_block.detail.all_amenities')}
          onClick={handleAllDynamicFieldsClick}
        >
          {t('kyrgyzstan_block.detail.all_amenities', {
            count: moreFieldsCount,
            amenity: t('kyrgyzstan_block.detail.amenity', {
              count: moreFieldsCount,
            }),
          })}
          <AppIcon
            id={AllIcons.CHEVRON_RIGHT}
            width={12}
            height={12}
            className={s.moreButtonIcon}
          />
        </button>
      )}
    </>
  )
}
